import React from "react";
import { Layout } from "./Layout";

export const NotFoundPage: React.VFC = () => (
  <Layout>
    <main>
      <div className="container">
        <h1>Not found</h1>
      </div>
    </main>
  </Layout>
);
